var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 15,
    fill: "url(#paint0_linear_400_4299)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_4299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0831 24.3332C42.711 24.6508 44.207 25.4469 45.3798 26.6197C46.5526 27.7925 47.3488 29.2886 47.6664 30.9165M41.0831 17.6665C44.4652 18.0422 47.619 19.5568 50.0268 21.9615C52.4345 24.3662 53.9531 27.5182 54.3331 30.8998M52.6664 44.1998V49.1998C52.6683 49.664 52.5732 50.1235 52.3872 50.5487C52.2013 50.974 51.9286 51.3558 51.5865 51.6696C51.2445 51.9834 50.8407 52.2223 50.401 52.371C49.9613 52.5197 49.4953 52.5749 49.0331 52.5332C43.9044 51.9759 38.9781 50.2234 34.6497 47.4165C30.6228 44.8576 27.2086 41.4435 24.6497 37.4165C21.833 33.0685 20.0801 28.1182 19.5331 22.9665C19.4914 22.5056 19.5462 22.0411 19.6939 21.6025C19.8416 21.164 20.079 20.761 20.391 20.4192C20.703 20.0774 21.0827 19.8044 21.506 19.6174C21.9294 19.4304 22.387 19.3336 22.8497 19.3332H27.8497C28.6586 19.3252 29.4427 19.6116 30.056 20.1391C30.6693 20.6665 31.0699 21.3989 31.1831 22.1998C31.3941 23.7999 31.7855 25.371 32.3497 26.8832C32.574 27.4797 32.6225 28.128 32.4896 28.7513C32.3566 29.3746 32.0478 29.9467 31.5997 30.3998L29.4831 32.5165C31.8557 36.6891 35.3105 40.1439 39.4831 42.5165L41.5997 40.3998C42.0529 39.9517 42.625 39.6429 43.2483 39.51C43.8715 39.3771 44.5199 39.4256 45.1164 39.6498C46.6285 40.2141 48.1996 40.6055 49.7997 40.8165C50.6093 40.9307 51.3487 41.3385 51.8773 41.9623C52.4058 42.5861 52.6867 43.3825 52.6664 44.1998Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_4299",
    x1: 4.8,
    y1: 75,
    x2: 72,
    y2: -0.00000248551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B2F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#043AE1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_4299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelphone);
export default __webpack_public_path__ + "static/media/telphone.f8a565b19586c4714fbec78d15a68933.svg";
export { ForwardRef as ReactComponent };